import { render, staticRenderFns } from "./TheFilterWheelSort.vue?vue&type=template&id=1d288c0e&scoped=true&"
import script from "./TheFilterWheelSort.vue?vue&type=script&lang=js&"
export * from "./TheFilterWheelSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d288c0e",
  null
  
)

export default component.exports